module.exports = __webpack_public_path__ + "static/media/background_pattern.fragment.97a6b8e3.glsl";